import { useSelector } from 'react-redux';
import { useServices } from '../ServicesContext';
import BoolAttribute from './boolAttribute';
import GuidAttribute from './guidAttribute';
import IntAttribute from './intAttribute';
import ListAttribute from './listAttribute';
import TextAttribute from './textAttribute';

export default function ServicesAttributes({
    serviceIndex,
    isBusy
}) {
    const { requiredScope } = useSelector((state) => {
        return { ...state.login };
    });
    const { originalData } = useServices();

    // leave it as it is when display order is same, otherwise sort
    return originalData[serviceIndex].attributes
        ?.sort((a, b) =>
            a.displayOrder === b.displayOrder
                ? 0
                : a.displayOrder - b.displayOrder,
        )
        ?.map((att, key) => {
            // defined attribute validation type is a json string
            const validation = JSON.parse(att.definedAttributeValidationType);
            switch (validation.Type) {
                case 'Int':
                    return (
                        <IntAttribute
                            index={key}
                            attribute={att}
                            serviceIndex={serviceIndex}
                            requiredScope={requiredScope}
                            isBusy={isBusy}
                        />
                    );
                case 'Text':
                    return (
                        <TextAttribute
                            index={key}
                            attribute={att}
                            serviceIndex={serviceIndex}
                            requiredScope={requiredScope}
                            isBusy={isBusy}
                        />
                    );

                case 'Bool':
                    return (
                        <BoolAttribute
                            index={key}
                            attribute={att}
                            serviceIndex={serviceIndex}
                            requiredScope={requiredScope}
                            isBusy={isBusy}
                        />
                    );

                case 'Guid':
                    return (
                        <GuidAttribute
                            index={key}
                            attribute={att}
                            serviceIndex={serviceIndex}
                            requiredScope={requiredScope}
                            isBusy={isBusy}
                        />
                    );

                case 'List':
                    return (
                        <ListAttribute
                            index={key}
                            attribute={att}
                            serviceIndex={serviceIndex}
                            requiredScope={requiredScope}
                            isBusy={isBusy}
                        />
                    );
                default:
                    break;
            }
        });
}
